import { createFileRoute, retainSearchParams } from "@tanstack/react-router"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { QualityTabsLayout } from "@/screens/Products/components/Product/Quality/ProductQualityTabsLayout"
import { ProductQualityTabPathname } from "@/screens/Products/components/Product/Quality/TestTemplates/types"

export const PRODUCT_QUALITY_LAYOUT_ROUTE_PATH = "/app/product/$productId/edit/_layout/quality/_layout"

export function getProductQualityTabRoute(
  productId: string,
  tab: ProductQualityTabPathname = ProductQualityTabPathname.Templates
): string {
  return `/app/product/${productId}/edit/quality/${tab}`
}

export const Route = createFileRoute(PRODUCT_QUALITY_LAYOUT_ROUTE_PATH)({
  search: {
    middlewares: [retainSearchParams([])],
  },
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.TEST_TEMPLATE_VIEW]}>
      <QualityTabsLayout />
    </PermissionContentWrapper>
  ),
})
